@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.support
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.support.SupportIssueDto

object GetSupportIssuesByCategoryEndpoint : EndPoint<GetSupportIssuesByCategoryEndpoint.Request, GetSupportIssuesByCategoryEndpoint.Response>() {
    class Request(
        val categoryId: KmmLong,
        val isActive: Boolean?,
        val pageNo: Int,
        val pageSize: Int,
        val searchTerm: String?,
    )

    class Response(
        val list: Array<SupportIssueDto>,
        val total: Int
    )
}